import { Box, Text } from 'grommet'
import React from 'react'

const LabelPill = ({ label }) => {
  return (
    <Box
      direction="row"
      align="center"
      gap="xsmall"
      pad={{ horizontal: 'small', vertical: 'xsmall' }}
      round="small"
      background={label.color}
      style={{ opacity: 0.9 }}>
      <Text size="small" weight={500} color="white">
        {label.name}
      </Text>
    </Box>
  )
}

export default LabelPill
